
import * as contentfulRuntime$sgrL5NoRb2u5ZOpC0V_J7XMM65fTW_45o1CMdG__456ihU4 from '/app/node_modules/@nuxt/image/dist/runtime/providers/contentful'
import * as scayleRuntime$uywk_QzyjHkjYJWJZLSg4J4QcwI2yQVUl9N5ljU_5_o from '/app/node_modules/@scayle/nuxt-image-provider/dist/index.mjs'
import * as snipesRuntime$tP_RVTTK5m7jC0m8tKG_kFfmSbOk5REMuZz6By0ZEVI from '/app/providers/snipes-image.ts'
import * as ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1440,
    "2xl": 1440
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['contentful']: { provider: contentfulRuntime$sgrL5NoRb2u5ZOpC0V_J7XMM65fTW_45o1CMdG__456ihU4, defaults: {"baseURL":"https://images.ctfassets.net","modifiers":{"quality":"85"}} },
  ['scayle']: { provider: scayleRuntime$uywk_QzyjHkjYJWJZLSg4J4QcwI2yQVUl9N5ljU_5_o, defaults: undefined },
  ['snipes']: { provider: snipesRuntime$tP_RVTTK5m7jC0m8tKG_kFfmSbOk5REMuZz6By0ZEVI, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
}
        